import { TFunction } from 'i18next';
import { AffectedSoftware, MBOSSynchronization } from '@/types';

export const VERSION_DESCRIPTION = 'Sprint 123';

export const efaContentID = 'efa-content';
export const efaContentParentID = 'efa-parent';

export const ENV = {
  LOCAL: 'local',
  DEV: 'development',
  INT: 'int',
  PRO: 'production',
};

export const ASC_ORDER = 'asc';
export const DESC_ORDER = 'desc';
export const CAPITAL_ASC = 'ASC';
export const CAPITAL_DESC = 'DESC';

export const CR_TYPE = {
  CAR: 'CAR',
  VAN: 'VAN',
};

export const ENV_MAP = {
  [ENV.LOCAL]: 'DEV',
  [ENV.DEV]: 'DEV',
  [ENV.INT]: 'INT',
  [ENV.PRO]: 'PRO',
};

// @ts-expect-error/next-line
export const env = window.ENV || import.meta.env.VITE_ENV || ENV.DEV;
export const isNotPRO = ![ENV.PRO].includes(env);
export const isDev = [ENV.DEV].includes(env);
export const isInt = [ENV.INT].includes(env);
export const isLocal = [ENV.LOCAL].includes(env);
export const isAzureEnv = window.location.hostname.includes('corpinter'); // @azureFix remove when back solve RD conectivity

// Notifications
export const LOADING = 'LOADING';
export const COMPLETED = 'COMPLETED';
export const SUCCESS = 'Success';
export const ERROR = 'ERROR';
export const WARNING = 'Warning';
export const MAX_NOTIFICATIONS = 8;
export const SERIES = 'SERIES';
export const PLANTS = 'PLANTS';

// Visibility / CR permissions Matrix values
export const WRITE = 'W';
export const READ = 'R';
export const HIDDEN = 'H';

// User Roles - Visibility Matrix Roles
export const CART_ROLE_PREFIX = 'CART.CaRT_';
export const CREATOR = 'Creator';
export const CREATOR_EXTERNAL = 'Creator_External';
export const COMMITTEE_COORDINATOR = 'Committee_Coordinator';
export const CENTER_VIEWER = 'Center_Viewer';
export const CAMPAIGN_MANAGER = 'Campaign_Manager';
export const CAMPAIGN_MANAGER_FILES = 'Campaign_Manager_CR';
export const REPORTER = 'Reporter';
export const RD_COMMITTEE_COORDINATOR = 'RD_Committee_Coordinator';
export const APPROVER = 'Approver';
export const CART_PLANT_SUPERVISOR = 'Plant_Supervisor';
export const CART_QMB_PLANT_APPROVER = 'QMB_Plant_Approver';
export const ADMIN = 'Admin';
export const VAN_COMMITTEE_COORDINATOR = 'Van_Committee_Coordinator';
export const VAN_E3_CAUSER = 'Van_E3_Causer';
export const VAN_E3_CHIEF_ENGINEER_CARLINE = 'Van_E3_Chief_Engineer_Carline';
export const VAN_E3_QMB_PLANT_APPROVER = 'Van_E3_QMB_Plant_Approver';
export const VAN_E2_QMB_APPROVER = 'Van_E2_QMB_Approver';
export const VAN_CAMPAIGN_MANAGER = 'Van_Campaign_Manager';

// JV roles
export const APPROVER_JV = 'Approver_JV';
export const CAMPAIGN_MANAGER_JV = 'Campaign_Manager_JV';
export const CREATOR_JV = 'Creator_JV';
export const QMB_PLANT_APPROVER_JV = 'QMB_Plant_Approver_JV';

// Kind of Permission (authorization.kindOfPermission)
export const NONE = 'NONE';
export const ADMIN_CR = 'ADMIN';
export const RECIPIENT_CR = 'AS_RECIPIENT';
export const STAND_IN_CR = 'STAND_IN';
export const CAMPAIGN_RECIPIENT_CR = 'AS_CAMPAIGN_RECIPIENT';

// Campaign roles - CR permissions Roles
export const CREATOR_CR = 'CREATOR';
export const CREATOR_EXTERNAL_CR = 'CREATOR_EXTERNAL';
export const REQUESTER_CR = 'REQUESTER';
export const APPROVER_CR = 'APPROVER';
export const INFORMER_APPROVER_CR = 'INFORMER_APPROVER';
export const INFORMER_PRE_APPROVER_CR = 'INFORMER_PRE_APPROVER';
export const INFORMER_CHECK_APPROVER_CR = 'INFORMER_CHECK_APPROVER';
export const CAMPAIGN_MANAGER_CR = 'CAMPAIGN_MANAGER';
export const COMMITTEE_COORDINATOR_CR = 'COMMITTEE_COORDINATOR';
export const RD_COMMITTEE_COORDINATOR_CR = 'RD_COMMITTEE_COORDINATOR';
export const QMB_PLANT_APPROVER_CR = 'QMB_PLANT_APPROVER';
export const E4_PLANT_SUPERVISOR_CR = 'PLANT_SUPERVISOR';
export const PLANT_SUPERVISOR_CR = 'PLANT_SUPERVISOR';
export const CAUSER_APPROVER_CR = 'CAUSER_APPROVER';
export const CAUSER_PRE_APPROVER_CR = 'CAUSER_PRE_APPROVER';
export const CAUSER_CHECK_APPROVER_CR = 'CAUSER_CHECK_APPROVER';
export const CENTER_VIEWER_CR = 'CENTER_VIEWER';
export const REPORTER_CR = 'REPORTER';
export const VAN_COMMITTEE_COORDINATOR_CR = 'VAN_COMMITTEE_COORDINATOR';
export const VAN_E3_CAUSER_CR = 'VAN_E3_CAUSER';
export const VAN_E3_CHIEF_ENGINEER_CARLINE_CR = 'VAN_E3_CHIEF_ENGINEER_CARLINE';
export const VAN_E3_QMB_PLANT_APPROVER_CR = 'VAN_E3_QMB_PLANT_APPROVER';
export const VAN_E2_QMB_APPROVER_CR = 'VAN_E2_QMB_APPROVER';
export const VAN_CAMPAIGN_MANAGER_CR = 'VAN_CAMPAIGN_MANAGER';

export const backRolesToOauthFormat = {
  CREATOR,
  REPORTER,
  CREATOR_EXTERNAL,
  CENTER_VIEWER,
  CAMPAIGN_MANAGER,
  CAMPAIGN_MANAGER_JV: CAMPAIGN_MANAGER_JV,
  CAMPAIGN_MANAGER_CR: CAMPAIGN_MANAGER_FILES,
  COMMITTEE_COORDINATOR,
  RD_COMMITTEE_COORDINATOR,
  APPROVER: APPROVER,
  APPROVER_JV: APPROVER_JV,
  CREATOR_JV: CREATOR_JV,
  QMB_PLANT_APPROVER_JV: QMB_PLANT_APPROVER_JV,
  QMB_PLANT_APPROVER: CART_QMB_PLANT_APPROVER,
  PLANT_SUPERVISOR: CART_PLANT_SUPERVISOR,
  ADMIN,
  VAN_COMMITTEE_COORDINATOR,
  VAN_E3_CAUSER,
  VAN_E3_CHIEF_ENGINEER_CARLINE,
  VAN_E3_QMB_PLANT_APPROVER,
  VAN_E2_QMB_APPROVER,
  VAN_CAMPAIGN_MANAGER,
};

export const errorRoleToFormatedRole = {
  E2_CR: 'E2 Approver',
  E3_CR: 'E3 Supervisor',
  E4_CR: 'E4 Supervisor',
  E3_SUBCR: 'QMB Plant Approver',
  E4_SUBCR: 'Plant Supervisor',
};

export const statusCampaign = {
  IN_CREATION: 'IN_CREATION',
  IN_RD_COMMITTEE: 'IN_RD_COMMITTEE',
  IN_INFORMER_CHECK: 'IN_INFORMER_CHECK',
  IN_CAUSER_CHECK: 'IN_CAUSER_CHECK',
  IN_INFORMER_PRE_APPROVAL: 'IN_INFORMER_PRE_APPROVAL',
  IN_CAUSER_PRE_APPROVAL: 'IN_CAUSER_PRE_APPROVAL',
  IN_INFORMER_APPROVAL: 'IN_INFORMER_APPROVAL',
  IN_CAUSER_APPROVAL: 'IN_CAUSER_APPROVAL',
  IN_PLANT_VALIDATION: 'IN_PLANT_VALIDATION',
  IN_COMMITTEE: 'IN_COMMITTEE',
  IN_PLANT_APPROVAL: 'IN_PLANT_APPROVAL',
  IN_PREPARATION_FOR_REVIEW: 'IN_PREPARATION_FOR_REVIEW', // Vans
  IN_REVIEW: 'IN_REVIEW', // Vans
  IN_VAN_CAUSER_APPROVAL: 'IN_VAN_CAUSER_APPROVAL', // Vans
  IN_CARLINE_CONFIRMATION: 'IN_CARLINE_CONFIRMATION', // Vans
  IN_QMB_VAN_INFORMATION: 'IN_QMB_VAN_INFORMATION', // Vans
  IN_PLANT_IMPLEMENTATION: 'IN_PLANT_IMPLEMENTATION', // Vans
  IN_VAN_PLANT_VALIDATION: 'IN_VAN_PLANT_VALIDATION', // Vans
  IN_VAN_PLANT_IMPLEMENTATION: 'IN_VAN_PLANT_IMPLEMENTATION', // Vans
  REQUESTED_FOR_CHANGES: 'REQUESTED_FOR_CHANGES',
  FINISHED: 'FINISHED',
  COMPLETED: 'COMPLETED',
  CLOSED: 'CLOSED',
  DELETED: 'DELETED',
} as const;

export const statusSubCampaign = {
  OPEN: 'OPEN',
  IN_CHECKING: 'IN_CHECKING',
  IN_CONSOLIDATION: 'IN_CONSOLIDATION', // Vans
  IN_ANALYSIS: 'IN_ANALYSIS',
  IN_PLANT_COORDINATION: 'IN_PLANT_COORDINATION',
  IN_E4_APPROVAL: 'IN_E4_APPROVAL',
  IN_E3_APPROVAL: 'IN_E3_APPROVAL',
  IN_VAN_PLANT_COORDINATION: 'IN_VAN_PLANT_COORDINATION', // Vans
  IN_PLANT_APPROVAL: 'IN_PLANT_APPROVAL',
  IN_PLANT_PREPARATION: 'IN_PLANT_PREPARATION',
  BLOCKED_BY_CHANGE_REQUEST: 'BLOCKED_BY_CHANGE_REQUEST',
  REQUESTED_FOR_CHANGES: 'REQUESTED_FOR_CHANGES',
  DELETED: 'DELETED',
  ACCEPTED: 'ACCEPTED',
  DENIED: 'DENIED',
  PLANT_NOT_AFFECTED: 'PLANT_NOT_AFFECTED',
} as const;

// Approvers
export const CAUSER = 'CAUSER';
export const INFORMER = 'INFORMER';
export const APPROVER_MIN_REQUIRED_LEVELS = {
  [CAUSER_APPROVER_CR]: 3,
  [QMB_PLANT_APPROVER_CR]: 4,
};

// Routes
export const BASE_PATH = '/front';

// Browser routes
export const ROUTES = {
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  CR_OVERVIEW: '/campaign-overview',
  SUB_CR_OVERVIEW: '/sub-campaign-overview',
  CR_DETAIL: '/campaign',
  SUB_CR_DETAIL: '/sub-campaign',
  ADMINISTRATION: '/administration',
  STAND_IN: '/stand-in',
  FILES: '/files',
  FILES_LIST: '/files-list',
  DENIED_PAGE: '/deniedPage',
  DESCRIPTION: '/description',
} as const;

// Absolute routes helper functions
export const getAbsoluteRoute = (route: string): string => `${BASE_PATH}${route}`;
export const isCurrentRoute = (route: keyof typeof ROUTES): boolean =>
  window.location.pathname === getAbsoluteRoute(ROUTES[route]);
export const isCurrentPath = (path: string): boolean =>
  window.location.pathname === getAbsoluteRoute(path);

export const SUPPORT_CHANNEL = isNotPRO
  ? 'https://teams.microsoft.com/l/channel/19%3A71cbb4d5d410453ca6f272ce2491536b%40thread.tacv2/02_Test%20Integration%20(INT)?groupId=5412bf06-d6dc-4770-891d-55a4e7f9a6f9&tenantId=9652d7c2-1ccf-4940-8151-4a92bd474ed0'
  : 'https://teams.microsoft.com/l/channel/19%3A--8yCQVX0RjzIZkq3lwNebmCZoBssQvHIhyZC29XKfc1%40thread.tacv2/01_General%20Topics%20(PROD)?groupId=5412bf06-d6dc-4770-891d-55a4e7f9a6f9&tenantId=9652d7c2-1ccf-4940-8151-4a92bd474ed0';

export const TABS = {
  description: { label: 'DESCRIPTION', link: 'description' },
  attachments: { label: 'ATTACHMENTS', link: 'attachments' },
  classification: { label: 'CLASSIFICATION', link: 'classification' },
  affectedHardware: { label: 'AFFECTED_HARDWARE', link: 'affected-hardware' },
  affectedSoftware: { label: 'AFFECTED_SOFTWARE', link: 'affected-software' },
  affectedVehicles: { label: 'AFFECTED_VEHICLES', link: 'affected-vehicles' },
  recipients: { label: 'RECIPIENTS', link: 'recipients' },
  feedback: { label: 'FEEDBACK', link: 'feedback' },
  translations: { label: 'TRANSLATIONS', link: 'translations' },
  vehicleStatusOverview: { label: 'VEHICLE_STATUS_OVERVIEW', link: 'vehicle-status-overview' },
  summary: { label: 'SUMMARY', link: 'summary' },
  summaryFeedback: { label: 'SUMMARY_FEEDBACK', link: 'summary-feedback' },
  plantFeedback: { label: 'PLANT_FEEDBACK', link: 'plant-feedback' },
  summaryPlantFeedback: { label: 'SUMMARY_PLANT_FEEDBACK', link: 'summary-plant-feedback' },
  involvedParties: { label: 'INVOLVED_PARTIES', link: 'involved-parties' },
  executiveSummary: { label: 'EXECUTIVE_SUMMARY', link: 'summary' },
};

export const campaignTabs = [
  TABS.description,
  TABS.attachments,
  TABS.classification,
  TABS.affectedHardware,
  TABS.affectedSoftware,
  TABS.affectedVehicles,
  TABS.recipients,
  TABS.translations,
  TABS.vehicleStatusOverview,
];

export const helpTextTabs = [
  TABS.description,
  TABS.attachments,
  TABS.classification,
  TABS.affectedHardware,
  TABS.affectedSoftware,
  TABS.affectedVehicles,
  TABS.recipients,
  TABS.translations,
  TABS.summary,
  TABS.feedback,
  TABS.summaryFeedback,
  TABS.plantFeedback,
  TABS.summaryPlantFeedback,
];

export const fieldsTabs = () => {
  const tabs = [
    TABS.description,
    // TABS.classification,
    // TABS.affectedSoftware,
    TABS.affectedVehicles,
    // TABS.involvedParties,
    // TABS.summary,
    // TABS.feedback,
  ];

  return tabs;
};

export const fieldsTabsToIndex = {
  description: 0,
  'affected-vehicles': 1,
  // classification: 1,
  // 'affected-software': 2,
  // summary: 5,
  // 'subcr-feedback': 6,
};

export const helpTabsToIndex = {
  description: 0,
  attachments: 1,
  classification: 2,
  'affected-hardware': 3,
  'affected-software': 4,
  'affected-vehicles': 5,
  recipients: 6,
  translations: 7,
  summary: 8,
  feedback: 9,
  'summary-feedback': 10,
  'summary-plant-feedback': 11,
};

export const campaignTabsToIndex = (plantValidation) => {
  const tabs: { [key: string]: number } = {
    description: 0,
    summary: 0,
    attachments: 1,
    'plant-feedback': 1,
    classification: 2,
    'affected-hardware': 3,
    'affected-software': 4,
    'affected-vehicles': 5,
    recipients: 6,
    translations: 7,
    'vehicle-status-overview': 8,
  };

  return tabs;
};

export const subCampaignTabsToIndex = (hideFeebacks: boolean) => {
  const tabs: { [key: string]: number } = {
    feedback: 0,
    summary: 0,
    description: 1,
    'plant-feedback': 1,
    attachments: 2,
    classification: 3,
    'affected-hardware': 4,
    'affected-software': 5,
    'affected-vehicles': 6,
    recipients: 7,
  };

  if (hideFeebacks) {
    return {
      summary: 0,
      // feedback: 0,
      description: 0,
      // 'plant-feedback': 1,
      attachments: 1,
      classification: 2,
      'affected-hardware': 3,
      'affected-software': 4,
      'affected-vehicles': 5,
      recipients: 6,
    };
  }

  return tabs;
};

export const fieldsTabsToBackKey = {
  description: 'CAMPAIGN_DESCRIPTION',
  // classification: 'CAMPAIGN_CLASSIFICATION',
  // 'affected-software': 'AFFECTED_SOFTWARE',
  'affected-vehicles': 'CAMPAIGN_AFFECTED_VEHICLES',
  // summary: 'EXECUTIVE_SUMMARY',
  // 'subcr-feedback': 'SUB_CAMPAIGN_FEEDBACK',
};

export const fieldsTabsToReduxState = {
  description: 'description',
  // classification: 'classification',
  // 'affected-software': 'software',
  'affected-vehicles': 'vehicles',
  // summary: 'summary',
  // 'subcr-feedback': 'subcrfeedback'
};

export const helpTabsToReduxState = {
  description: 'description',
  attachments: 'attachments',
  classification: 'classification',
  'affected-hardware': 'affectedHardware',
  'affected-software': 'affectedSoftware',
  'affected-vehicles': 'affectedVehicles',
  recipients: 'recipients',
  translations: 'translations',
  summary: 'summary',
  feedback: 'feedback',
  'summary-feedback': 'summaryFeedback',
  'summary-plant-feedback': 'summaryPlantFeedback',
};

export const summaryTabs = [
  TABS.executiveSummary,
  TABS.plantFeedback,
];

export const campaigns = 'campaigns';

export const subCRSummaryTabs = [
  TABS.executiveSummary,
  TABS.plantFeedback,
];

export const subCampaignsTabs = [
  TABS.feedback,
  TABS.description,
  TABS.attachments,
  TABS.classification,
  TABS.affectedHardware,
  TABS.affectedSoftware,
  TABS.affectedVehicles,
  TABS.recipients,
];

export const stateTabs = {
  description: 'description',
  attachments: 'attachments',
  classification: 'classification',
  'affected-hardware': 'affectedHardware',
  'affected-software': 'affectedSoftware',
  'affected-vehicles': 'affectedVehicles',
  recipients: 'recipients',
  summary: 'summary',
  translations: 'translations',
  feedback: 'feedback',
  'plant-feedback': 'plantFeedback',
  'summary-feedback': 'summaryFeedback',
  'summary-plant-feedback': 'summaryPlantFeedback',
};

export const TAB_FORMS_OPTIONS = {
  CAMP_CLASSIFICATION: 'CAMPAIGN_CLASSIFICATION',
  CAMP_DESCRIPTION: 'CAMPAIGN_DESCRIPTION',
  CAMP_AFF_VEHICLES: 'CAMPAIGN_AFFECTED_VEHICLES',
  CAMP_RECIPIENTS: 'CAMPAIGN_RECIPIENTS',
  CAMP_VAN_RECIPIENTS: 'CAMPAIGN_VAN_RECIPIENTS',
  SUB_CAMP_FEEDBACK: 'SUB_CAMPAIGN_FEEDBACK',
  AFFECTED_SOFTWARE: 'AFFECTED_SOFTWARE',
};

export const volumeList = {
  CLEAN_DIRTY_POINT: 'affectedVehicles.CLEAN_DIRTY_POINT',
  CODE_RULE: 'affectedVehicles.CODE_RULE',
  COUNTRY_VARIANTS: 'affectedVehicles.COUNTRY_VARIANTS',
  AGGREGATE: 'affectedVehicles.AGGREGATE',
  PAINT_CODE: 'affectedVehicles.PAINT_CODE',
  VEHICLE_MODEL_DESIGNATION: 'affectedVehicles.VEHICLE_MODEL_DESIGNATION',
  SUMMARY: 'affectedVehicles.SUMMARY',
};

// Base routes
const adminRoutesBase = {
  '/administration/plants': 'administration.plants',
  '/administration/model-series': 'affectedVehicles.modelSeries',
  '/administration/params-configuration': 'menu.paramsConfiguration',
  '/administration/workflow-duration': 'menu.workflowDuration',
  '/administration/help/description': 'menu.helpAutor',
  '/administration/help/summary': 'menu.helpAutor',
  '/administration/help/classification': 'menu.helpAutor',
  '/administration/help/affected-hardware': 'menu.helpAutor',
  '/administration/help/affected-software': 'menu.helpAutor',
  '/administration/help/affected-vehicles': 'menu.helpAutor',
  '/administration/help/recipients': 'menu.helpAutor',
  '/administration/help/attachments': 'menu.helpAutor',
  '/administration/help/translations': 'menu.helpAutor',
  '/administration/help/feedback': 'menu.helpAutor',
  '/administration/help/summary-feedback': 'menu.helpAutor',
  '/administration/help': 'menu.helpAutor',
  '/administration/newsfeed': 'menu.newsfeed',
  '/administration/fields/description': 'menu.fields',
  // '/administration/fields/classification': 'menu.fields',
  '/administration/fields/affected-vehicles': 'menu.fields',
  '/administration/fields': 'menu.fields',
  '/administration/product-groups': 'menu.productGroup',
  '/administration/sums-criteria': 'menu.sumsCriteria',
  '/administration/stand-ins': 'menu.standIns',
  '/administration/emails': 'menu.emails',
  '/administration/emails/templates': 'menu.templateSection',
  '/administration/emails/templates/:emailId': 'menu.workflowSection',
};

// Dynamic administration routes
export const administration = Object.keys(adminRoutesBase).reduce((acc, route) => {
  const routeWithPrefix = getAbsoluteRoute(route);
  acc[routeWithPrefix] = adminRoutesBase[route];

  return acc;
}, {} as Record<string, string>);

export const adminPagesWithTabs = ['fields', 'help'];

// Language
export const ENGLISH = 'EN';
export const GERMAN = 'DE';
export const LANGUAGES_ABBREVIATION = [ENGLISH, GERMAN];
export const NOT_TRANSLATABLE = 'NOT_TRANSLATABLE';
export const defaultLanguage = ENGLISH.toLowerCase();

export const YES = 'Yes';
export const NO = 'No';

export const DOORMAN_PREFIX_EN = 'DMP: ';
export const DOORMAN_PREFIX_DE = 'TSP: ';

export const getFileIcon = (extension) => {
  switch (extension) {
    case 'mp3':
      return 'icon-datei-mp3';
    case 'mp4':
      return 'icon-datei-mp4';
    case 'xls':
    case 'xlsx':
      return 'icon-datei-xls';
    case 'txt':
      return 'icon-datei-text';
    case 'csv':
      return 'icon-datei-csv';
    case 'pdf':
      return 'icon-datei-pdf';
    case 'ppt':
    case 'pptx':
      return 'icon-datei-pptx';
    case 'doc':
    case 'docx':
      return 'icon-datei-doc';
    default:
      return 'icon-datei-text';
  }
};

export const ALL = 'ALL';

export const imgExtensionsFile = ['jpg', 'jpeg', 'png', 'bmp', 'wbmp', 'gif'];
export const allExtensionsFile = [
  ...imgExtensionsFile,
  'mp3',
  'mp4',
  'xls',
  'xlsx',
  'txt',
  'csv',
  'pdf',
  'ppt',
  'pptx',
  'doc',
  'docx',
  'msg',
];
export const allExtensionsAccept = `.${allExtensionsFile.join(', .')}`;

export const LANGUAGES = [
  { name: 'English', code: 'en' },
  { name: 'German', code: 'de' },
];

export const EMPTY_USERINFO_OBJECT = {
  code: '',
  department: '',
  summary: '',
};

export const fieldsFromMBOS = ['description', 'uuidCode'];

export const fieldsFromDialog = ['numberNew', 'description', 'modelSeries', 'typeVersions', 'codeCondition', 'btvPerson'];

export const HARDWARE_WITHOUTPART_TABLE_ID = 'hardware-withoutpart';
export const HARDWARE_WITHPART_TABLE_ID = 'hardware-withpart';

export const tablesWithAddDialogInfoToRedux = {
  'software-flashingParts': 'flashingParts',
  'software-codingParts': 'codingParts',
  [HARDWARE_WITHOUTPART_TABLE_ID]: 'partWithoutChange',
  [HARDWARE_WITHPART_TABLE_ID]: 'partWithChange',
};

export const tablesWithAddDialogInfo = Object.keys(tablesWithAddDialogInfoToRedux);
export const tablesWithAddDialogInfoRedux = Object.values(tablesWithAddDialogInfoToRedux);

export const tablesWithAddMBOSInfo = ['software-codingParts', 'software-flashingParts'];

const DIALOG_SYNC_DEFAULT = {
  updatedByDialog: false,
  dialogUpdateDate: '',
  dialogFieldsSynchronized: [],
  dialogUpdateInitialData: fieldsFromDialog.reduce((acc, field) => ({ ...acc, [field]: field === 'btvPerson' ? EMPTY_USERINFO_OBJECT : '' }), {}),
};

const MBOS_SYNC_DEFAULT: MBOSSynchronization = {
  isSynchronized: false,
  synchronizedFields: [],
  synchronizedData: {
    description: undefined,
    uuidCode: undefined,
  },
};

const defaultRow = (isSoftwareRow = false, isUUID = false) => ({
  [isUUID ? 'uuidCode' : 'numberNew']: '',
  affectedPlants: '',
  description: '',
  codeCondition: '',
  modelSeries: '',
  typeVersions: '',
  zgsOld: '',
  zgsNew: '',
  additionalInformation: '',
  ...(isSoftwareRow ? { kemOld: '', kemNew: '' } : { qeLevel: '', vpd: '', perVehicle: '' }),
  ...(isUUID ? {} : { dialogSynchronization: DIALOG_SYNC_DEFAULT, ywpVersionOld: '', ywpVersionNew: '' }),
  ...(!isUUID && isSoftwareRow ? { mbosSynchronization: MBOS_SYNC_DEFAULT } : {}),
});

export const softwareTableDialogRows = (software: AffectedSoftware, isRDMP = false, partNumber = '') => ({
  codingParts: [{
    ...defaultRow(true),
    ...((software?.otaUpdate === YES && software?.coding) && {
      diogenesName: '',
      ecuIsCodeable: 'No',
      hwPartNo: '',
    }),
    qnt: '',
    meaning: '',
    numberOld: '',
    ...(partNumber ? { numberNew: partNumber } : {}),
    ...(isRDMP ? { btvPerson: EMPTY_USERINFO_OBJECT } : {}),
    uuidCode: '',
  }],
  codingUuids: [{
    ...defaultRow(true, true),
    ...((software?.otaUpdate === YES && software?.coding) && {
      diogenesName: '',
      ecuIsCodeable: 'No',
      hwUuidNo: '',
    }),
    qnt: '',
    meaning: '',
    uuidCodeOld: '',
    ...(isRDMP ? { uuidPersonResponsible: EMPTY_USERINFO_OBJECT } : {}),
  }],
  flashingParts: [{
    ...defaultRow(true),
    ...((software?.otaUpdate === YES && software.flashing) && {
      diogenesName: '',
      ecuIsCodeable: 'No',
      hwPartNo: '',
    }),
    numberOld: '',
    ...(isRDMP ? { btvPerson: EMPTY_USERINFO_OBJECT } : {}),
    uuidCode: '',
  }],
  flashingUuids: [{
    ...defaultRow(true, true),
    ...((software?.otaUpdate === YES && software.flashing) && {
      diogenesName: '',
      ecuIsCodeable: 'No',
      hwUuidNo: '',
    }),
    uuidCodeOld: '',
    ...(isRDMP ? { uuidPersonResponsible: EMPTY_USERINFO_OBJECT } : {}),
  }],
  doormanParts: [{
    doormanBundleId: '',
    affectedMarkets: '',
    partNaming: '',
    partNumber: '',
    qntNumber: '',
    expectedRelease: '',
    freeText: '',
  }],
  doormanUuids: [{
    doormanBundleId: '',
    affectedMarkets: '',
    uuidNaming: '',
    uuidCode: '',
    qntNumber: '',
    expectedRelease: '',
    freeText: '',
  }],
});

export const tableDialogRows = (isRDMP = false, partNumber = '') => ({
  hardwareaffectsChina: [{
    ...defaultRow(),
    numberOld: '',
    typeApprovalNumber: '',
    manufacturer: '',
    ...(isRDMP ? { btvPerson: EMPTY_USERINFO_OBJECT } : {}),
  }],
  hardwarePartWithChange: [{
    ...defaultRow(),
    numberOld: '',
    ...(isRDMP ? { btvPerson: EMPTY_USERINFO_OBJECT } : {}),
    ...(partNumber ? { numberNew: partNumber } : {}),
  }],
  hardwareWithoutPartChange: [{
    ...defaultRow(),
    ...(isRDMP ? { btvPerson: EMPTY_USERINFO_OBJECT } : {}),
    ...(partNumber ? { numberNew: partNumber } : {}),
  }],
});

export const AFFECTED = 'AFFECTED';
export const chinaAffected = { NOT_AFFECTED: 'NoAffected', NO: 'No', YES: 'Yes' };

export const descriptionIssues = ['PROBLEM_DESCRIPTION', 'ROOT_CAUSE', 'CONSEQUENCES', 'IMMEDIATE_MEASURE'];

export const getPartNumberEditingExtensions = (isPDRS: boolean) => [
  { columnName: isPDRS ? 'numberOld' : 'numberNew', editingEnabled: false },
  { columnName: 'modelSeries', editingEnabled: false },
  { columnName: 'typeVersions', editingEnabled: false },
];

export const tableDialogTitles = {
  numberNew: 'software.partNoNew',
  uuidCode: 'software.uuidCode',
  description: 'software.description',
  diogenesName: 'software.diogenesName',
  ecuIsCodeable: 'software.ecuIsCodeable',
  hwPartNo: 'software.hwPartNo',
  hwUuidNo: 'software.hwUuidNo',
  numberOld: 'software.partNoOld',
  uuidCodeOld: 'software.uuidCodeOld',
  modelSeries: 'software.modelSeries',
  typeVersions: 'software.typeVersions',
  codeCondition: 'software.codeCondition',
  affectedPlants: 'software.affectedPlants',
  qeLevel: 'hardware.qeLevel',
  additionalInformation: 'software.additionalInformation',
  zgsOld: 'software.zgsold',
  zgsNew: 'software.zgsnew',
  perVehicle: 'software.perVehicle',
  qntNumber: 'software.qnt',
  qnt: 'software.qnt',
  meaning: 'software.meaning',
  typeApprovalNumber: 'hardware.typeApprovalNumber',
  manufacturer: 'hardware.manufacturer',
  doormanBundleId: 'software.doormanBundle',
  affectedMarkets: 'software.affectedMarket',
  partNaming: 'software.partNaming',
  partNumber: 'software.partNumber',
  uuidNaming: 'software.uuidNaming',
  uuidNumber: 'software.uuidNumber',
  expectedRelease: 'software.expectedDoorman',
  freeText: 'software.doormanAditionalInfo',
  vpd: 'hardware.vpd',
  ywpVersionOld: 'software.ywpVersionOld',
  ywpVersionNew: 'software.ywpVersionNew',
  kemOld: 'software.kemOld',
  kemNew: 'software.kemNew',
};

export const TABLE_FIELD_MAX_LENGTH: Record<string, number> = {
  numberNew: 32,
  uuidCode: 128,
  uuidNumber: 32,
  uuidCodeOld: 128,
  description: 512,
  numberOld: 32,
  modelSeries: 32,
  typeVersions: 128,
  codeCondition: 1024,
  affectedPlants: 1024,
  additionalInformation: 512,
  zgsOld: 32,
  zgsNew: 32,
  perVehicle: 1024,
  qnt: 128,
  meaning: 512,
  diogenesName: 512,
  hwUuidNo: 128,
  hwPartNo: 128,
  kemNew: 128,
  kemOld: 128,
  ywpVersionNew: 32,
  ywpVersionOld: 32,
  typeApprovalNumber: 512,
  manufacturer: 512,
  doormanBundleId: 512,
  affectedMarkets: 512,
  partNaming: 512,
  partNumber: 32,
  uuidNaming: 512,
  qntNumber: 128,
  expectedRelease: 512,
  freeText: 512,
  qeLevel: 4,
};

export const actionTakenSubCampaign = {
  REQUESTED_FOR_CHANGES: 'REQUESTED_FOR_CHANGES',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  CLOSED: 'CLOSED',
  CREATED: 'CREATED',
  COPIED: 'COPIED',
  SENT_TO_APPROVAL: 'SENT_TO_APPROVAL',
  DELETED: 'DELETED',
  NO_ACTION_TAKEN: 'NO_ACTION_TAKEN',
  APPROVED: 'APPROVED',
  SENT_TO_E3_APPROVAL: 'SENT_TO_E3_APPROVAL',
  SENT_TO_E4_APPROVAL: 'SENT_TO_E4_APPROVAL',
  SENT_TO_ANALYSIS: 'SENT_TO_ANALYSIS',
};

export const dialogDecisionOptions = {
  APPROVED: 'APPROVED',
  SEND_TO_APPROVAL: 'SEND_TO_APPROVAL',
  CHANGE: 'CHANGE',
  REJECTED: 'REJECTED',
  PLANT_NOT_AFFECTED: 'PLANT_NOT_AFFECTED',
};

export const goToSummaryStatuses = [
  statusCampaign.IN_PLANT_VALIDATION,
  statusCampaign.IN_VAN_PLANT_VALIDATION,
  statusCampaign.IN_INFORMER_APPROVAL,
  statusCampaign.IN_CAUSER_APPROVAL,
  statusCampaign.IN_INFORMER_PRE_APPROVAL,
  statusCampaign.IN_CAUSER_PRE_APPROVAL,
  statusCampaign.IN_INFORMER_CHECK,
  statusCampaign.IN_CAUSER_CHECK,
  statusCampaign.IN_RD_COMMITTEE,
  statusCampaign.CLOSED,
  statusCampaign.COMPLETED,
  statusCampaign.DELETED,
];

export const userActions = {
  copy: 'copy',
  delete: 'delete',
  add: 'add',
};

export const mapperModelSeries = (modelSeries = [], plantSelected) => {
  let body = {};
  modelSeries.forEach((currentModelSerie: any) => {
    const plants = Object.keys(currentModelSerie.typeVersions).filter((plant) => {
      const codes = currentModelSerie.typeVersions[plant].map((p) => p.wkzNumber);

      return codes.includes(plantSelected.wkzNumber);
    });

    body = {
      ...body,
      [currentModelSerie.serie]: plants,
    };
  });

  return body;
};

export const initDeleteVolume = (currentVolume) => {
  currentVolume.limitationVolumeManualEntry.countryVariantsSelecteds = [];
  currentVolume.limitationVolumeManualEntry.countryVariantsSelectionAccording = 'AFFECTED';
  currentVolume.limitationVolumeManualEntry.aggregateComment = '';
  currentVolume.limitationVolumeManualEntry.aggregateSelecteds = [];
  currentVolume.limitationVolumeManualEntry.aggregateSelectionAccording = 'AFFECTED';
  currentVolume.limitationVolumeManualEntry.paintCodeComment = '';
  currentVolume.limitationVolumeManualEntry.paintCodeSelecteds = [];
  currentVolume.limitationVolumeManualEntry.paintCodeSelectionAccording = 'AFFECTED';
  currentVolume.limitationVolumeManualEntry.specialEquipmentComment = '';
  currentVolume.limitationVolumeManualEntry.specialEquipmentSelecteds = [];
  currentVolume.limitationVolumeManualEntry.specialEquipmentSelectionAccording = 'AFFECTED';
  currentVolume.limitationVolumeManualEntry.vehicleModelDesignationComment = '';
  currentVolume.limitationVolumeManualEntry.vehicleModelDesignationSelecteds = [];
  currentVolume.limitationVolumeManualEntry.vehicleModelDesignationSelectionAccording = 'AFFECTED';
  currentVolume.limitationVolumeManualEntry.codeRules = [];
  currentVolume.limitationVolumeManualEntry.dirtPoint = {
    dates: [],
    fromStartOfProductions: [],
    otherDescriptions: [],
    productionNumbers: [],
    shiftNumbers: [],
    ttzs: [],
    vehicleIdentificationNumbers: [],
    releases: [],
  };
  currentVolume.limitationVolumeManualEntry.vehiclesOK = {
    dates: [],
    otherDescriptions: [],
    productionNumbers: [],
    shiftNumbers: [],
    ttzs: [],
    vehicleIdentificationNumbers: [],
    releases: [],
  };
};

export const highlightedFieldsInitialState = {
  isSelectionMode: false,
  selectedFields: {},
  reviewerComment: '',
};

// Workflow (WF) status width
export const WF_STATUS_WIDTH = {
  THRESHOLD: 200,
  MIN: 100,
  OPEN: 300,
  MAX: 500,
};

// Help sidebar width
export const HELP_WIDTH = {
  MIN: 500,
  MAX: 160,
};

export const STORAGE = {
  USER_CODE: 'cart.user',
  SIGN_IN_REDIRECT: 'cartSigninRedirect',
  LAST_ROUTE: 'cartLastRoute',
  LAST_UTC: 'cart.lastUTC',
  PREVIOUS_TAB: 'cart.previousTab',
  TRANSLATION_DIALOG_SHOW: 'cart.TranslationDialogShow',
  LAST_OVERVIEW: 'cart.lastOverview',
  LAST_ACTION_WAS_LOGIN: 'cart.lastActionWasLogin',
  RESET_TOKEN_TRIED: 'cart.resetTokenTried',
};

// Values stored under STORAGE.LAST_OVERVIEW
export const LAST_OVERVIEW_VALUES = {
  CAMPAIGN_OVERVIEW: 'campaignOverview',
  SUB_CAMPAIGN_OVERVIEW: 'subCampaignOverview',
};

export const DAY_DATE_FORMAT = 'yyyy-MM-dd';
export const SHORT_HOUR_DATE_FORMAT = 'HH:mm';
export const LONG_HOUR_DATE_FORMAT = 'HH:mm:ss';
export const SHORT_FULL_DATE_FORMAT = `${DAY_DATE_FORMAT} - ${SHORT_HOUR_DATE_FORMAT}`;
export const LONG_FULL_DATE_FORMAT = `${DAY_DATE_FORMAT} - ${LONG_HOUR_DATE_FORMAT}`;

export const workflowOptions = {
  E2C: 'ICA',
  E2I_E2C: 'IIA_ICA',
  E4I_E3I_E2I_E2C: 'IIC_IIPA_IIA_ICA',
  E4C_E3C_E2C: 'ICC_ICPA_ICA',
  DYNAMIC: 'DYNAMIC',
};

export const approvalWorkflowStatusesList = {
  causerApprover: 'ICA',
  causerCheckApprover: 'ICCA',
  causerPreApprover: 'ICPA',
  informerApprover: 'IIA',
  informerCheckApprover: 'IICA',
  informerPreApprover: 'IIPA',
};

export const URLDashboard = {
  de: {
    base: 'https://social.intra.corpintra.net/groups/cart',
    faq: 'https://social.intra.corpintra.net/groups/cart/pages/faq',
    learn: 'https://social.cloud.corpintra.net/groups/cart/pages/training',
  },
  en: {
    base: 'https://social.cloud.corpintra.net/groups/cart-campaign-request-tool-en',
    faq: 'https://social.cloud.corpintra.net/groups/cart-campaign-request-tool-en/pages/faq',
    learn: 'https://social.cloud.corpintra.net/groups/cart-campaign-request-tool-en/pages/training',
  },
};

// Classification
export const CHINA_COMBO_ORDER = ['NoAffected', 'No', 'Yes'];

// URLS
export const TEAMS_LINK = 'https://teams.app.corpintra.net/teams/';
export const TEAMS_PERSON = `${TEAMS_LINK}person/`;
export const TEST_ALICE = 'https://alice-int.mercedes-benz.com/access/accessRequest/myself';
export const PROD_ALICE = 'https://alice.mercedes-benz.com/access/accessRequest/myself';

// Involved Parties
export const EMPTY_SUPPLIIER = {
  id: '',
  globalCode: '',
  name: '',
  addressStreet: '',
  addressPostalCode: '',
  addressCity: '',
  addressCountry: '',
};

export const CLOSE_CAMPAIGN_FORM = {
  fields: [
    { name: 'comment', label: 'campaign.deleteComment' },
    { name: 'translation', label: 'translations.translateTo' },
  ],
  invalid: true,
  comment: {
    value: '',
    touched: false,
    errors: { required: false, min: false, max: false, invalid: false },
  },
  translation: {
    value: '',
    touched: false,
    errors: { required: false, min: false, max: false, invalid: false },
  },
};

export const SKIP_DIALOG_AREAS = [
  {
    name: 'creation',
    statuses: ['CRE'],
    comment: '',
  },
  {
    name: 'informers',
    statuses: ['E2I', 'E3I', 'E4I'],
    comment: 'commentsInformerApprover',
  },
  {
    name: 'causers',
    statuses: ['E2C', 'E3C', 'E4C'],
    comment: 'commentsCauserApprover',
  },
  {
    name: 'finished',
    statuses: ['FIN'],
    comment: '',
  },
];

export const chipTypes = {
  WITH_FUNCTION: 'WITH_FUNCTION',
  WITHOUT_FUNCTION: 'WITHOUT_FUNCTION',
  READONLY: 'READONLY',
  WITHOUT_FUNCTION_TABLE: 'WITHOUT_FUNCTION_TABLE',
};

export const langWithLocale = {
  EN: 'en-us',
  DE: 'de-de',
};

export const errorTypes = { // TODO: rename to toastTypes
  NOT_OKNOK_IN_GROUPS_ERROR: 'NOT_OKNOK_IN_GROUPS_ERROR',
  LOAD_CAMPAIGN_ERROR: 'LOAD_CAMPAIGN_ERROR',
  LOAD_SUBCAMPAIGN_ERROR: 'LOAD_SUBCAMPAIGN_ERROR',
  CHAR_NOT_ALLOWED_FREETEXT: 'CHAR_NOT_ALLOWED_FREETEXT',
  CAMPAIGN_NUMBER_ALREADY_EXISTS: 'campaign_number_found_in_sub_campaign',
  LANGUAGE_WARNING: 'LANGUAGE_WARNING',
  LANGUAGE_WARNING_TRANSLATIONS: 'LANGUAGE_WARNING_TRANSLATIONS',
  ABORT_ERROR: 'AbortError',
  ONLY_ONE_PLANT: 'plant_exists_in_product_group',
  BOTH_CODING_AND_FLASHING_ACTIVE: 'both_coding_and_flashing_active',
  MODEL_SERIES_COMBINATION_ERROR: 'affected_model_series_combination_not_allowed',
  SERIES_BY_PLANT_NOT_ALLOWED: 'series_by_plant_not_allowed',
  SERIES_BY_PLANT_PARTIALLY_NOT_ALLOWED: 'series_by_plant_partially_not_allowed',
  ZASM_CREATE_CAMPAIGN_ERROR: 'zasm_create_campaign_error',
  ZASM_SYNC_CAMPAIGN_ERROR: 'zasm_sync_campaign_error',
  ZASM_SERVER_ERROR: 'zasm_server_error',
  MBOS_SERVER_ERROR: 'mbos_server_error',
  duplicate_campaign_number_in_sub_campaign: 'duplicate_campaign_number_in_sub_campaign',
  software_remote_update_alert: 'software_remote_update_alert',
  mandatory_fields_empty: 'mandatory_fields_empty',
  ywp_version_format_error: 'ywp_version_format_error',
  campaign_should_close_by_doorman_status: 'campaign_should_close_by_doorman_status',
  software_ywp_version_alert: 'software_ywp_version_alert',
  NON_EXISTING_MBOS_PART: 'mbos_part_not_exist',
  ZASM_CAMPAIGN_NOT_FOUND: 'zasm_campaign_not_found',
  ZASM_PLANT_NOT_AVAILABLE: 'zasm_incompatible_plant_error',
  EMAIL_TEMPLATE_ACTIVE: 'email_template_still_in_use',
  SFM_NUMBER_LENGTH_ERROR: 'sfm_number_wrong_length',
};

export const DOORMAN_PROCESS_KEY = 'DOORMAN_PROCESS';

export const tabSubCRToNotesState = {
  description: 'descriptionNotes',
  classification: 'classificationNotes',
  'affected-hardware': 'hardwareNotes',
  'affected-software': 'softwareNotes',
  'affected-vehicles': 'vehiclesNotes',
};

export const fieldTypes = {
  CALENDAR: 'CALENDAR',
  DROPDOWN: 'DROPDOWN',
  MULTI_SELECTION: 'MULTI_SELECTION',
  INPUT_USER: 'INPUT_USER',
  ACCORDION: 'ACCORDION',
  SWITCH: 'SWITCH',
  INPUT_NUMBER: 'INPUT_NUMBER',
  CUSTOM_ARRAY: 'CUSTOM_ARRAY',
  INPUT_TEXT: 'INPUT_TEXT',
  CHIP: 'CHIP',
  CHECKBOX: 'CHECKBOX',
};

export const tabsCRSearchOrdered = () => {
  const tabs: { [key: string]: string } = {
    feedback: 'feedback',
    campaign: 'description',
    description: 'description',
    classification: 'classification',
    affectedHardware: 'affected-hardware',
    affectedSoftware: 'affected-software',
    affectedVehicles: 'affected-vehicles',
    recipients: 'recipients',
  };

  return tabs;
};

export enum filterPills {
  allRequests = 'allRequests',
  myOpenRequests = 'myOpenRequests',
  myRequests = 'myRequests',
  representativeApplications = 'representativeApplications',
  requestsToApprove = 'requestsToApprove',
  deletedRequests = 'deletedRequests',
  coordinationToPlantApproval = 'coordinationToPlantApproval',
  inPlantConsolidation = 'inPlantConsolidation',
  notAssigned = 'notAssigned',
  assignedToMe = 'assignedToMe',
  closedRequests = 'closedRequests',
  assignedToMeSubCr = 'assignedToMeSubCr',
  notAssignedSubCr = 'notAssignedSubCr',
  inPlantApprovalSubCr = 'inPlantApprovalSubCr',
  requestsToAcknowledge = 'requestsToAcknowledge',
  requestsToApproveSubCr = 'requestsToApproveSubCr',
}

export const KEYBOARD_KEYS = {
  ENTER: 'Enter',
  COMMA: ',',
  BACKSPACE: 'Backspace',
};

export const ALPHABETIC_REGEX = /^[a-zA-Z]+$/;

export const WESPLink = 'https://social.cloud.corpintra.net/apps/app-station?appId=2149311';
export const SocialIntranetSUMS = 'https://social.cloud.corpintra.net/community/unternehmen/rd/sums-de';

export const qmbApprover = 'qmbApprover';
export const supervisor = 'supervisor';

export const collapsedLabelsWorkflow = (t: TFunction) => ({
  IN_CREATION: t('workflow.IN_CREATION'),
  IN_INFORMER_APPROVAL: t('statusBarLabels.IN_INFORMER_APPROVAL'),
  IN_CAUSER_APPROVAL: t('statusBarLabels.IN_CAUSER_APPROVAL'),
  IN_INFORMER_PRE_APPROVAL: t('statusBarLabels.IN_INFORMER_PRE_APPROVAL'),
  IN_CAUSER_PRE_APPROVAL: t('statusBarLabels.IN_CAUSER_PRE_APPROVAL'),
  IN_INFORMER_CHECK: t('statusBarLabels.IN_INFORMER_CHECK'),
  IN_CAUSER_CHECK: t('statusBarLabels.IN_CAUSER_CHECK'),
  COMPLETED: t('workflow.COMPLETED'),
  CLOSED: t('workflow.CLOSED'),
  DELETED: t('workflow.DELETED'),
  BLOCKED_BY_CHANGE_REQUEST: t('workflow.BLOCKED_BY_CHANGE_REQUEST'),
  IN_PLANT_VALIDATION: t('workflow.IN_PLANT_VALIDATION'),
  IN_COMMITTEE: t('workflow.IN_COMMITTEE'),
  IN_PLANT_APPROVAL: t('workflow.IN_PLANT_APPROVAL'),
  IN_RD_COMMITTEE: t('workflow.IN_RD_COMMITTEE'),
  IN_PREPARATION_FOR_REVIEW: t('workflow.IN_PREPARATION_FOR_REVIEW'),
  IN_REVIEW: t('workflow.IN_REVIEW'),
  IN_VAN_CAUSER_APPROVAL: t('workflow.IN_VAN_CAUSER_APPROVAL'),
  IN_CARLINE_CONFIRMATION: t('workflow.IN_CARLINE_CONFIRMATION'),
  IN_QMB_VAN_INFORMATION: t('workflow.IN_QMB_VAN_INFORMATION'),
  IN_PLANT_IMPLEMENTATION: t('workflow.IN_PLANT_IMPLEMENTATION'),
  IN_VAN_PLANT_VALIDATION: t('workflow.IN_VAN_PLANT_VALIDATION'),
  IN_VAN_PLANT_IMPLEMENTATION: t('workflow.IN_VAN_PLANT_IMPLEMENTATION'),
  REQUESTED_FOR_CHANGES: t('workflow.REQUESTED_FOR_CHANGES'),
  OPEN: t('workflow.OPEN'),
  IN_ANALYSIS: t('workflow.IN_ANALYSIS'),
  IN_CHECKING: t('workflow.IN_CHECKING'),
  IN_E4_APPROVAL: 'E4',
  IN_E3_APPROVAL: 'E3',
  DENIED: t('workflow.DENIED'),
  ACCEPTED: t('workflow.ACCEPTED'),
  IN_PLANT_COORDINATION: t('workflow.IN_PLANT_COORDINATION'),
  IN_VAN_PLANT_COORDINATION: t('workflow.IN_VAN_PLANT_COORDINATION'),
});

export const formYESNO = { NO: { DE: 'Nein', EN: 'No' }, YES: { DE: 'Ja', EN: 'Yes' } };
export const formCRTypes = { CAR: { DE: 'CAR', EN: 'CAR' }, VAN: { DE: 'VAN', EN: 'VAN' }, CARVAN: { DE: 'CAR&VAN', EN: 'CAR&VAN' } };

export const propsForNonTypeScriptComponent: any = {};

export const CUSTOM_COLUMNS_TYPES = {
  USERS_SELECTION: 'USERS_SELECTION',
  MULTI_SELECTION: 'MULTI_SELECTION',
  DROPDOWN: 'DROPDOWN',
  CHECKBOX: 'CHECKBOX',
  RADIO_BUTTON: 'RADIO_BUTTON',
  TEXT: 'TEXT',
  UNIQUE_USER_SELECTION: 'UNIQUE_USER_SELECTION',
  TYPE_VERSIONS_CHIP_INPUT: 'TYPE_VERSIONS_CHIP_INPUT',
  OPTIONS_CUSTOM: 'OPTIONS_CUSTOM',
};

export const ERROR_TYPES_ADD_STANDIN = {
  standIn_no_role: 'standIn_no_role',
  standIn_rd_mp: 'standIn_rd_mp',
  standIn_rolecr_rolesubcr: 'standIn_rolecr_rolesubcr',
  standIn_of_rolecr_rolesubcr: 'standIn_of_rolecr_rolesubcr',
};

export const FILE_STATUS = {
  COMPLETED: 'COMPLETED',
  LOADING: 'LOADING',
};

export const WORKFLOW_TYPE_FORM = {
  NOT_READY: { DE: 'Nicht bereit', EN: 'Not ready' },
  DIGITAL: { DE: 'Digital WF bereit', EN: 'Digital WF ready' },
};

export const SELECTION_MODES_FORM = {
  MODEL_SERIES: { DE: 'Via Baureihe', EN: 'Via Model Series' },
  PLANTS: { DE: 'Via Werk', EN: 'Via Plants' },
  BOTH: { DE: 'Beide', EN: 'Both' },
};

export const WORKFLOW_TYPE = {
  NOT_READY: 'NOT_READY',
  DIGITAL: 'DIGITAL',
} as const;

export const ZASM_CAMPAIGN_LINK = {
  PRO: 'https://zasm.i.mercedes-benz.com/zasm/campaign-ui-service/#!/campaign',
  INT: 'https://zasm-int.i.mercedes-benz.com/zasm/campaign-ui-service/#!/campaign',
};

export const ZASM_SELECTION_LINK = {
  PRO: 'https://zasm.i.mercedes-benz.com/zasm/campaign-ui-service/#!/selection',
  INT: 'https://zasm-int.i.mercedes-benz.com/zasm/campaign-ui-service/#!/selection',
};

export const INTAKT_CAMPAIGN_LINKS = {
  PRO: 'https://intakt.prod.gspp-eu.aftersales.mercedes-benz.com/intakt/factory-campaign/search',
  INT: 'https://intakt.int.gspp-eu.aftersales.mercedes-benz.com/intakt/factory-campaign/search',
};

export const EMPTY_LANG_COMMENT = {
  [ENGLISH]: '',
  [GERMAN]: '',
};

export const filterField = {
  CLASSIFICATION: 'CLASSIFICATION',
  TRIGGER_SOURCE: 'TRIGGER_SOURCE',
  GB18285_RELEVANCE: 'GB18285_RELEVANCE',
  CUSTOMER_RELEVANCY: 'CUSTOMER_RELEVANCY',
  BLOCKING_RECOMMENDATION: 'BLOCKING_RECOMMENDATION',
  AFFECTED_PLANTS: 'AFFECTED_PLANTS',
  AFFECTED_MODEL_SERIES: 'AFFECTED_MODEL_SERIES',
  IRA_NO: 'IRA_NO',
  CAUSER: 'CAUSER',
  SUPPLIER_NO: 'SUPPLIER_NO',
  POSSIBLE_CAUSER: 'POSSIBLE_CAUSER',
  SUPPLIER_NAME: 'SUPPLIER_NAME',
  PART_NO: 'PART_NO',
  CAMPAIGN_NUMBER: 'CAMPAIGN_NUMBER',
  FREE_TEXT: 'FREE_TEXT',
  TYPE: 'TYPE',
  TIER1_SUPPLIER_NAME: 'TIER1_SUPPLIER_NAME',
};

export const CAMPAING = 'CAMPAIGN';
export const STATUS = 'status';
export const CREATED = 'created';
export const VERSION_DATE = 'versionDate';
export const VERSION_DATE_RAW = 'versionDateRaw';
export const CREATED_RAW = 'createdRaw';
export const CREATION_DATE_RAW = 'creationDateRaw';
export const MAIN_CR = 'CR';
export const MAIN_CR_FIELD = 'mainCR';
export const CR_PATH = 'cr';
export const SUB_CR = 'SUBCR';
export const SUB_CR_FIELD = 'SubCR';
export const SUB_CR_PATH = 'subCR';
export const STATUS_FILTER_SEPARATOR = '::';

export const VANS_LABEL = ' (VANS)';

export const YWP_VERSION_NEW = 'ywpVersionNew';
export const YWP_VERSION_OLD = 'ywpVersionOld';

export const HEADER_TO_FILTER = {
  affectedPlants: 'AFFECTED_PLANTS',
  classification: 'CLASSIFICATION',
  affectedModelSeries: 'AFFECTED_MODEL_SERIES',
  triggerSource: 'TRIGGER_SOURCE',
  affectsChina: 'GB18285_RELEVANCE',
  blockingRecommendation: 'BLOCKING_RECOMMENDATION',
  customerRelevance: 'CUSTOMER_RELEVANCY',
  locationInternal: 'CAUSER',
  mbosRelevance: 'MB_OS_RELEVANCY',
  possibleCauser: 'POSSIBLE_CAUSER',
  supplierNumber: 'SUPPLIER_NO',
  supplierName: 'SUPPLIER_NAME',
  tier1SupplierNumber: 'TIER1_SUPPLIER_NO',
  tier1SupplierName: 'TIER1_SUPPLIER_NAME',
  contactPersonMP: 'CONTACT_PERSON_MP',
  campaign: 'CAMPAIGN_NUMBER',
  iraNumber: 'IRA_NO',
  partNumbers: 'PART_NO',
  type: 'TYPE',
};

export const INTERNAL = 'INTERNAL';
export const EXTERNAL = 'EXTERNAL';

export const UTC = 'UTC';

export const VAN_ROLES = [VAN_COMMITTEE_COORDINATOR, VAN_E3_CAUSER, VAN_E3_CHIEF_ENGINEER_CARLINE, VAN_E3_QMB_PLANT_APPROVER, VAN_E2_QMB_APPROVER,
  VAN_CAMPAIGN_MANAGER] as const;

export const pathWebSocketConfigParams = '/topic/config-global-updates';

export const FIELD_PARAMS = {
  DOCMASTER_LINK: 'docmasterLink',
};

export const PDRS = 'PDRS';
export const SDR = 'SDR';

// Vehicle Status Overview Column Names
export const VEHICLE_STATUS_OVERVIEW_COLUMNS = {
  MAIN_CR: 'mainCr',
  SUB_CR: 'subCr',
  CAMPAIGN: 'campaign',
  DYNAMIC: 'dynamic',
  BLOCKING_LOCATION: 'blockingLocation',
  ESTIMATED_CARS: 'estimatedCars',
  VALIDATED_CARS: 'validatedCars',
  NO_REWORK: 'noRework',
  REWORK_NOT_STARTED: 'reworkNotStarted',
  REWORK_OPEN: 'reworkOpen',
  REWORK_FINISHED: 'reworkFinished',
  OK_WITHOUT_REWORK: 'okWithoutRework',
  REWORK_IN_FIELD: 'reworkInField',
};

export const VEHICLE_STATUS_COMMON_COUNT_COLUMNS = [
  VEHICLE_STATUS_OVERVIEW_COLUMNS.VALIDATED_CARS,
  VEHICLE_STATUS_OVERVIEW_COLUMNS.REWORK_NOT_STARTED,
  VEHICLE_STATUS_OVERVIEW_COLUMNS.NO_REWORK,
  VEHICLE_STATUS_OVERVIEW_COLUMNS.REWORK_OPEN,
  VEHICLE_STATUS_OVERVIEW_COLUMNS.REWORK_FINISHED,
  VEHICLE_STATUS_OVERVIEW_COLUMNS.OK_WITHOUT_REWORK,
  VEHICLE_STATUS_OVERVIEW_COLUMNS.REWORK_IN_FIELD,
];

export const FIELDS_DISABLED_BY_PDRS = [
  'editTitle', // header
  'description.source', 'description.buildUpApproval', 'description.triggerComment', // description
  `description.problems.${descriptionIssues[0]}`, 'description.location', 'description.locationExternal.supplierNumber',
  'description.locationExternal.supplierName',
  'recipients.approvalWorkflow', 'recipients.responsibleRequester', 'recipients.CAUSER_CHECK_APPROVER', // recipients
  'recipients.CAUSER_PRE_APPROVER', 'recipients.CAUSER_APPROVER', 'recipients.add-causer-approver',
  'recipients.remove-causer-approver', 'recipients.INFORMER_PRE_APPROVER', 'recipients.INFORMER_APPROVER',
  'recipients.add-informer-approver', 'recipients.remove-informer-approver',
  'affectedVehicles.seriesPanel', // affected vehicles
];

export const isFileOnlyUser = (authService) => {
  const userRoles = authService.getUserRole(true);

  return userRoles.length === 1 && userRoles[0] === CAMPAIGN_MANAGER_FILES;
};

export const additionalContactPerson = 'additionalContactPerson';
export const codingParts = 'codingParts';
export const codingUuids = 'codingUuids';
export const uuidCodeOld = 'uuidCodeOld';

export const SOFTWARE = {
  CODING: 'coding',
  FLASHING: 'flashing',
  OTA_UPDATE: 'otaUpdate',
  SFM_REQUESTED: 'sfmRequested',
  OTA_COMMENT: 'otaComment',
  IS_MBOS: 'isMbos',
  RELEASE_FLASHABLE: 'releaseFlashable',
  AFFECTED_SOFTWARE: 'affectedSoftware',
};

export const RECIPIENTS = {
  E3_QMB_APPROVER: 'e3QMBApprover',
  APPROVAL_WORKFLOW: 'approvalWorkflow',
  RESPONSIBLE_REQUESTER: 'responsibleRequester',
  STAND_IN: 'standIn',
  CAUSER_APPROVER: 'causerApprover',
  CAUSER_PRE_APPROVER: 'causerPreApprover',
  INFORMER_CHECK_APPROVER: 'informerCheckApprover',
  E3_CHIEF_ENGINEER: 'e3ChiefEngineer',
  E2_QMB_INFORMER: 'e2QMBInformer',
};

export const AFF_VEHICLES = {
  AMG: 'amgVehicles',
};

export const DESCRIPTION = {
  TRIGGER_COMMENT: 'triggerComment',
  PROBLEMS: 'problems',
  INSPECTION_COMMENT: 'inspectionComment',
  SOURCE: 'source',
  FAILURE_OCCURRED_ON: 'failureOccurredOn',
  CONTACT_PERSON_SUPPL_MANAGEMENT: 'contactPersonSupplierManagement',
  POSSIBLE_CAUSER: 'possibleCauser',
  COST_COVERAGE_ACKNOWLEDGED: 'costCoverageAcknowledged',
  CONTACT_PERSON: 'contactPerson',
  CONTACT_PERSON_MP: 'contactPersonMP',
  IRA_NUMBER: 'iraNumber',
  REF_SYSTEM: 'referenceSystem',
  REF_SYSTEM_NAME: 'referencedSystemName',
  BUILD_UP_APPROVAL: 'buildUpApproval',
  FAULT_LOCATION: 'faultLocation',
  FAULT_TYPE: 'faultType',
  SELECTED_MODEL_SERIES: 'selectedModelSeries',
  TIER1_SUPPLIER: {
    FIELD: 'tier1',
    NUMBER: 'tier1SupplierNumber',
    NAME: 'tier1SupplierName',
    ADDRESS: 'tier1SupplierAddress',
  },
  SUPPLIER: {
    FIELD: 'supplier',
    NUMBER: 'supplierNumber',
    NAME: 'supplierName',
    ADDRESS: 'supplierAddress',
  },
  POSSIBLE_CAUSER_SELECTED: 'possibleCauserSelected',
  POSSIBLE_CAUSER_INTERNAL: {
    CAUSER: 'possibleCauserPossibleCauser',
    COST_CENTER: 'possibleCauserCostCenter',
    CONFIRM_PLANT_TO_PLANT: 'confirmPlantToPlant',
  },
  POSSIBLE_CAUSER_EXTERNAL: {
    CONTACT_PERSON: 'possibleCauserContactPersonForSupplierManagement',
    SUPPLIER_NUMBER: 'possibleCauserSupplierNumber',
    SUPPLIER_NAME: 'possibleCauserSupplierName',
    TIER1_NUMBER: 'possibleCauserTier1SupplierNumber',
    TIER1_NAME: 'possibleCauserTier1SupplierName',
    TIER1_SUPP_ACKN: 'tier1SupplierAcknowledged',
  },
};

export const ADDRESS = 'ADDRESS';
export const NAME = 'NAME';
export const NUMBER = 'NUMBER';
export const LAST_NAME = 'lastName';
export const FIRST_NAME = 'firstName';
export const DEPARTMENT = 'department';
export const USER_CODE = 'userCode';
export const USER_ID = 'userId';
export const SUPPLIER_ID = 'supplierId';
export const SUPPLIER_NAME_FIELD = 'supplierName';
export const ALL_FIELDS = 'allFields';

export const POSSIBLE_CAUSER_INPUT_IDS = {
  SUPPLIER_NUMBER: 'supplier-number',
  SUPPLIER_NAME: 'supplier-name',
  TIER1_SUPPLIER_NUMBER: 'tier1-supplier-number',
  TIER1_SUPPLIER_NAME: 'tier1-supplier-name',
};

export const FEEDBACK = {
  FEEDBACK: 'feedback',
  TOTAL: 'total',
  EXT_REWORK: 'externalReworkTimes',
  INT_REWORK: 'internalReworkTimes',
  SHUNTING_ALWAYS: 'shuntingAlways',
  SHUNTING_REWORK: 'shuntingWithRework',
  INSPECTION: 'inspection',
  REWORK: 'rework',
  DIAGNOSIS: 'diagnosis',
  ROLLER_TEST: 'rollerTest',
  BILLING: 'billing',
  COST_CENTER: 'costCenter',
  PM_CONTRACT: 'pmContract',
  CO_NUMBER: 'coNumber',
};

export const CLASSIFICATION = {
  CLASSIFICATION: 'classification',
  CONSULTATION_TYPE: 'consultationType',
  NO_CONSULTATION: 'No consultation',
  RELEVANCE_COMMENT: 'relevanceComment',
  CUSTOMER_RELEVANCE_CHOSEN: 'customerRelevanceChosen',
  CUSTOMER_RELEVANCE: 'customerRelevance',
  POTENTIALLY_SCE_RELEVANT: 'potentiallySCECertificationRelevant',
  CONSULTATION_NAME: 'consultantName',
  CONSULTATION_DATE: 'consultationDate',
  CONSULTATION_COMMENT: 'consultationComment',
  BLOCKING_RECOMENDATION: 'blockingRecommendation',
  CRASH_CERTIFICATION_VEHICLES: 'crashCertificationVehicles',
  DEVELOPMENT_VEHICLE_POOLING: 'developmentVehiclePooling',
  SELECT_OPTIONS: {
    POT_EMISSION: 'pot. Emission',
    POT_SAFETY: 'pot. Safety',
    POT_REG_CONF: 'pot. Regulatory Conformity',
    POT_CERTIF: 'pot. Certification',
  },
  AFFECTS_CHINA: 'affectsChina',
};

export const classificationSelectOptions = [
  CLASSIFICATION.SELECT_OPTIONS.POT_EMISSION,
  CLASSIFICATION.SELECT_OPTIONS.POT_SAFETY,
  CLASSIFICATION.SELECT_OPTIONS.POT_REG_CONF,
  CLASSIFICATION.SELECT_OPTIONS.POT_CERTIF,
];

export const OVERVIEW_COLUMNS = {
  BLOCKING_LOCATIONS: 'blockingLocations',
  ESTIMATED_CARS: 'estimatedAmountOfVehicles',
  VALIDATED_CARS: 'validatedAmountOfVehicles',
  NO_REWORK: 'noRework',
  REWORK_NOT_STARTED: 'reworkNotStarted',
  REWORK_OPEN: 'reworkOpen',
  REWORK_FINISHED: 'reworkFinished',
  OK_WITHOUT_REWORK: 'okWithoutRework',
  REWORK_IN_FIELD: 'reworkInField',
};

export const ATTACHMENT_SECTION = {
  BEFORE_QMB: 'BEFORE_QMB_DECISION',
  AFTER_QMB: 'AFTER_QMB_DECISION',
};

export const ATTACHMENT_TAGS = {
  PROBLEM_DESCRIPTION: 'PROBLEM_DESCRIPTION',
  TEST_INSTRUCTION: 'TEST_INSTRUCTION',
  REWORK_INSTRUCTION: 'REWORK_INSTRUCTION',
  ADDITIONAL_ATTACHMENTS: 'ADDITIONAL_ATTACHMENTS',
  CART_REQUEST: 'CART_REQUEST',
};

export const getAttachmentTag = (attachment: Record<string, unknown> = {}) => (attachment?.tag || attachment?.documentTag || '') as string;

export const getAttachmentJvVisible = (attachment: Record<string, unknown> = {}) => {
  if (typeof attachment?.jointVentureVisible === 'boolean') return attachment.jointVentureVisible;
  if (typeof attachment?.visibleForJV === 'boolean') return attachment.visibleForJV;

  return false;
};

export const JV_VISIBLE = 'jvVisible';

export enum HELP_AREA {
  ATTACHMENTS = 'ATTACHMENTS',
  TRANSLATIONS = 'TRANSLATIONS',
  REQUIREMENTS = 'REQUIREMENTS',
  PART_AVAIBILITY = 'PART_AVAIBILITY',
  PROBLEM_OVERVIEW = 'PROBLEM_OVERVIEW',
  AFFECTED_VEHICLES = 'AFFECTED_VEHICLES',
  WORKFLOW = 'WORKFLOW',
  REQUESTER = 'REQUESTER',
  APPROVER_CAUSER = 'APPROVER_CAUSER',
  APPROVER_INFORMER = 'APPROVER_INFORMER',
  PLANTS_APPROVAL_VANS = 'PLANTS_APPROVAL_VANS',
  QMB_INFORMATION_VANS = 'QMB_INFORMATION_VANS',
  PLANT_FEEDBACK = 'PLANT_FEEDBACK',
  APPROVER = 'APPROVER',
  APPROVER_COMMENT_VANS = 'APPROVER_COMMENT_VANS',
  MANAGER_ENTRY = 'MANAGER_ENTRY',
  PROBLEM = 'PROBLEM',
  VOLUME = 'VOLUME',
  RELEVANCE = 'RELEVANCE',
  CONSULTATION = 'CONSULTATION',
  BLOCKING_RECOMENDATION = 'BLOCKING_RECOMENDATION',
  AFFECTS_CHINA = 'AFFECTS_CHINA',
  DEVELOPMENT_VEHICLE_ASSESSMENT = 'DEVELOPMENT_VEHICLE_ASSESSMENT',
  FLASHING_REMOTE_SOFTWARE_UPDATE = 'FLASHING_REMOTE_SOFTWARE_UPDATE',
  WITH_CODING = 'WITH_CODING',
  FLASHING_INFORMATION = 'FLASHING_INFORMATION',
  WITH_FLASHING = 'WITH_FLASHING',
  TECHNICAL_ASSESSMENT = 'TECHNICAL_ASSESSMENT',
  TRIGGER = 'TRIGGER',
  ISSUE_RESOLUTION_PROCESS = 'ISSUE_RESOLUTION_PROCESS',
  INSPECTION = 'INSPECTION',
  POSSIBLE_CAUSER = 'POSSIBLE_CAUSER',
  SERIES = 'SERIES',
}

export const NOSAMPLE = 'NOSAMPLE';

export const NUMERIC_FIELDS = {
  REQUEST_NO: 'request-number',
  INPUT_NO: 'input-number',
  INPUT_VEHICLE_VOLUME_NO: 'input-vehicle-volume-numbers',
  SFM_REQUEST_NO: 'sfm-request-number',
};

export const COMMENT_FIELD = 'comment' as const;

export const REQUIRED_SFM_LENGHT_NUMBER = 5;
